export default __webpack_public_path__ + "static/media/pp11.c8d9b2c0.png";